module.exports = __webpack_public_path__ + "media/images/illust/illust-case02-8eb870767bbb3a9947b62e2b96565099.svg";